module.exports = __webpack_public_path__ + "static/media/background_9.ec709d14.png";